/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Category_CleanInputs */

const en_tasks_category_clean = /** @type {(inputs: Tasks_Category_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clean`)
};

const fr_tasks_category_clean = /** @type {(inputs: Tasks_Category_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nettoyage`)
};

const ms_sg2_tasks_category_clean = /** @type {(inputs: Tasks_Category_CleanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembersihan`)
};

/**
* | output |
* | --- |
* | "Clean" |
*
* @param {Tasks_Category_CleanInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_category_clean = /** @type {((inputs?: Tasks_Category_CleanInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Category_CleanInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_category_clean(inputs)
	if (locale === "fr") return fr_tasks_category_clean(inputs)
	return ms_sg2_tasks_category_clean(inputs)
});